import React from 'react'

let id = 0

export default function useUniqueId() {
  return React.useMemo(() => ++id, [])
}
